import React from 'react';

export function placeholderhelper(el) {
    let placeholder = 'TT.MM.JJJJ';
    let placeholderhelper = placeholder.slice(el.length).split('.');
    let placeholderhelperString = '';
    let classes = 'hide';
    if (el.indexOf('.') > 0) {
        classes += ' expand';
    }
    placeholderhelperString += '<span class="' + classes + '">' + el + '</span>';
    Object.keys(placeholderhelper).forEach((k) => {
        placeholderhelperString +=
            '<span class="' + placeholderhelper[k].slice(0, 1).toLowerCase() + '">' + placeholderhelper[k] + '</span>';
        if (placeholderhelper.length > parseInt(k) + 1) {
            placeholderhelperString += '.';
        }
    });

    return <div className="placeholder-helper" dangerouslySetInnerHTML={{ __html: placeholderhelperString }}></div>;
}

export function makeHash(length) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
